import { Component } from "react"
import Top from "./Top"
import Bottom from "./Bottom"
import ProductReduct from "./ProductReduce"
import "./index.css"
import "./ProductReduce.css"
import "./PageLayout.css"

class ProjectsPage extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">案例与教学素材</h1>
            <p className="page-subtitle">展示课程中的实际项目案例和教学资源</p>
          </div>
          <ProductReduct />
        </div>
        <Bottom />
      </div>
    )
  }
}

export default ProjectsPage